module.exports = __webpack_public_path__ + "img/service.dfb0c15f.gif";